import Upgrade from "../Upgrade";
import UpgradeCreator from "./UpgradeCreator";

/**
 * @abstract
 */
export default class FreeUpgrade extends Upgrade {
    /**
     * @param {UpgradeCreator} upgradeCreator
     * @param {string} title
     * @param {string} iconFileName
     */
    constructor(upgradeCreator, title, iconFileName) {
        super(title, iconFileName);

        /**
         * @constant
         * @type {UpgradeCreator}
         */
        this.upgradeCreator = upgradeCreator;
    }

    /**
     * @returns {string}
     */
    getCreatorId() {
        return this.upgradeCreator.id;
    }

    /**
     * @abstract
     * @returns {boolean}
     */
    isCombineSupported() {
        return false;
    }

    /**
     * @override
     * @returns {boolean}
     */
    isPurchasable() {
        return this.purchasedCount === 0;
    }

    /**
     * @override
     * @returns {boolean}
     */
    isAffordable() {
        return true;
    }

    /**
     * @override
     * @returns {boolean} true if the purchase was made.
     */
    purchase() {
        // Prevent double-purchase
        if (this.purchasedCount > 0) {
            return false;
        }

        this.purchasedCount++;

        // Let the subclass know that a purchase has been made
        this.onUpgradePurchased();

        return true;
    }

    /**
     * Invoked by the base class to let the sub-class know that a purchase has been made.
     * @abstract
     */
    onUpgradePurchased() {}

}